import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'debuff',
    apply: ({ state, source, params }) => {
        const stat = params.stat ?? 'atk';
        const amountPct = params.amountPct ?? 0.1;
        const duration = params.duration ?? 5;
        const targetSide = enemySide(source.side);
        const targets = livingEnemies(state, source.side).map(e => ({ slot: e.slot }));
        for (const t of targets) {
            getRuntimes(state, targetSide)[t.slot].statuses.push({
                id: `debuff_${stat}_${state.tick}_${t.slot}`,
                kind: 'debuff',
                remainingTicks: duration,
                params: { [stat]: amountPct }
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: targetSide, slot: t.slot, status: 'debuff', duration });
        }
    }
});
